import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Auth
      login: 'Login',
      register: 'Register',
      logout: 'Logout',
      username: 'Username',
      password: 'Password',
      marketName: 'Market Name',
      selectLanguage: 'Select Language',
      signIn: 'Sign In',
      signUp: 'Sign Up',
      dontHaveAccount: "Don't have an account?",
      alreadyHaveAccount: 'Already have an account?',
      
      // Dashboard
      dashboard: 'Dashboard',
      welcome: 'Welcome',
      totalItems: 'Total Items',
      lowStockItems: 'Low Stock Items',
      totalValue: 'Total Inventory Value',
      totalValueBuying: 'Total Inventory Value (Buying)',
      totalValueSelling: 'Total Inventory Value (Selling)',
      recentItems: 'Recent Items',
      noStock: 'No stock',
      
      // Items
      items: 'Items',
      addItem: 'Add Item',
      editItem: 'Edit Item',
      deleteItem: 'Delete Item',
      toggleItemStatus: 'Toggle Item Status',
      deactivateItem: 'Deactivate Item',
      activateItem: 'Activate Item',
      itemDeactivated: 'Item deactivated successfully',
      itemActivated: 'Item activated successfully',
      frozenItems: 'Frozen Items',
      sellingPriceLowerWarning: 'Warning: Selling price is lower than buying price',
      expiryBeforeProductionError: 'Expiry date must be after production date',
      cannotDeactivateItemWithStock: 'Cannot deactivate item with stock. Stock must be zero.',
      cannotDeleteCategoryWithItems: 'Cannot delete category with items',
      cannotDeleteBrandWithItems: 'Cannot delete brand with items',
      cannotDeleteItemWithBatches: 'Cannot delete item with batches',
      cannotDeleteItemWithSales: 'Cannot delete item with sold batches',
      cannotDeleteBatchWithSales: 'Cannot delete batch that has been sold',
      itemName: 'Item Name',
      description: 'Description',
      barcode: 'Barcode',
      sku: 'SKU',
      buyingPrice: 'Buying Price',
      sellingPrice: 'Selling Price',
      currency: 'Currency',
      lbp: 'Lebanese Pound (L.L)',
      usd: 'US Dollar ($)',
      lbpSymbol: 'L.L',
      usdSymbol: '$',
      exchangeRate: 'Exchange Rate',
      generalExchangeRate: 'General Exchange Rate (1 USD = X LBP)',
      customExchangeRate: 'Custom Exchange Rate (Optional)',
      updateExchangeRate: 'Update Exchange Rate',
      exchangeRateUpdated: 'Exchange rate updated successfully',
      updatePhone: 'Update Phone Number',
      currentPhone: 'Current Phone',
      notSet: 'Not Set',
      languageUpdated: 'Language updated successfully',
      quantity: 'Quantity',
      category: 'Category',
      lowStockThreshold: 'Low Stock Threshold',
      profitMargin: 'Profit Margin',
      active: 'Active',
      inactive: 'Inactive',
      save: 'Save',
      cancel: 'Cancel',
      search: 'Search',
      filter: 'Filter',
      
      // Batches
      batch: 'Batch',
      batches: 'Batches',
      addBatch: 'Add Batch',
      editBatch: 'Edit Batch',
      batchCode: 'Batch Code',
      batchBarcode: 'Batch Barcode',
      numberOfBoxes: 'Number of Boxes',
      itemsPerBox: 'Items Per Box',
      boxBuyingPrice: 'Box Buying Price',
      boxSellingPrice: 'Box Selling Price',
      unitBuyingPrice: 'Unit Buying Price',
      unitSellingPrice: 'Unit Selling Price',
      calculated: 'Auto-calculated',
      autoCalculatedFromBox: 'Auto-calculated from box price, can be edited',
      totalBatchQuantity: 'Total Quantity in Batch',
      items: 'items',
      productionDate: 'Production Date',
      expiryDate: 'Expiry Date',
      exp: 'Exp',
      alertDays: 'Alert Days (before expiry)',
      daysUntilExpiry: 'Days Until Expiry',
      expiringBatches: 'Batches Near Expiry',
      expiredBatches: 'Expired Batches',
      batchStatus: 'Batch Status',
      ok: 'OK',
      alert: 'Alert',
      expired: 'Expired',
      batchAddedSuccess: 'Batch added successfully',
      batchUpdatedSuccess: 'Batch updated successfully',
      batchDeletedSuccess: 'Batch deleted successfully',
      cannotEditBatchCode: 'Batch code cannot be modified after creation',
      updateBatch: 'Update Batch',
      cancelEdit: 'Cancel Edit',
      noBatches: 'No batches for this item',
      atLeastOneBatch: 'At least one batch is required',
      totalItems: 'Total Items',
      addedBatches: 'Added Batches',
      noBatchCode: 'No Code',
      boxes: 'box(es)',
      unit: 'unit',
      numberOfBatches: 'Number of Batches',
      totalQuantity: 'Total Quantity',
      totalBoxes: 'Total Boxes',
      
      // Messages
      loginSuccess: 'Logged in successfully',
      loginError: 'Invalid credentials',
      registerSuccess: 'Registration successful',
      itemAddedSuccess: 'Item added successfully',
      itemUpdatedSuccess: 'Item updated successfully',
      itemDeletedSuccess: 'Item deleted successfully',
      error: 'An error occurred',
      
      // Common
      yes: 'Yes',
      no: 'No',
      delete: 'Delete',
      edit: 'Edit',
      view: 'View',
      actions: 'Actions',
      
      // POS
      pos: 'Point of Sale',
      pointOfSale: 'Point of Sale',
      cart: 'Cart',
      cartEmpty: 'Cart is empty',
      searchItems: 'Search items...',
      searchItemsOrBarcode: 'Search by name or scan barcode...',
      addedToCart: 'added to cart',
      itemNotFound: 'Item not found',
      stock: 'Stock',
      checkout: 'Checkout',
      paymentMethod: 'Payment Method',
      cash: 'Cash',
      card: 'Card',
      both: 'Both',
      bothCurrency: 'USD + LBP',
      debt: 'Debt',
      customer: 'Customer',
      addCustomer: 'Add Customer',
      selectCustomer: 'Select Customer',
      selectCustomerForDebt: 'Customer required for debt payment',
      customerName: 'Customer Name',
      customerPhone: 'Customer Phone',
      remainingDebt: 'Remaining Debt',
      receipt: 'Receipt',
      print: 'Print',
      generatedOn: 'Generated on',
      newSale: 'New Sale',
      thankYou: 'Thank you for your purchase!',
      saleCompleted: 'Sale completed successfully',
      errorCreatingSale: 'Error creating sale',
      insufficientStock: 'Insufficient stock',
      totalUSD: 'Total (USD)',
      totalLBP: 'Total (LBP)',
      qty: 'Qty',
      price: 'Price',
      total: 'Total',
      item: 'Item',
      back: 'Back',
      sold: 'Sold',
      popularItems: 'Popular Items',
      allItems: 'All Items',
      noItems: 'No items available',
      refresh: 'Refresh',
      totalSales: 'Total Sales',
      convertedTo: 'converted to',
      grandTotal: 'Grand Total',
      
      // Unit Types & Measurements
      unitType: 'Unit Type',
      unitTypeHint: 'Select how this item is measured/sold',
      unitTypeQuantity: 'Quantity (Pieces)',
      unitTypeWeight: 'Weight (kg)',
      unitTypeLength: 'Length (m)',
      unitTypeArea: 'Area (m²)',
      unitTypeVolume: 'Volume (L)',
      allowFractional: 'Allow Decimal Quantities',
      allowFractionalHint: 'Allow fractional values like 0.5, 1.25, 2.75',
      weightKg: 'Weight (kg)',
      lengthM: 'Length (m)',
      areaM2: 'Area (m²)',
      volumeL: 'Volume (L)',
      kg: 'kg',
      meter: 'm',
      squareMeter: 'm²',
      liter: 'L',
      pieces: 'pieces',
      enterWeight: 'Enter Weight',
      enterLength: 'Enter Length',
      enterArea: 'Enter Area',
      enterVolume: 'Enter Volume',
      enterValidMeasurement: 'Please enter a valid measurement',
      availableQuantity: 'Available',
      confirm: 'Confirm',
      
      // Reports
      reports: 'Reports',
      profitsAndReports: 'Profits & Reports',
      profitByItem: 'Profit by Item',
      totalProfitUSD: 'Total Profit (USD)',
      totalProfitLBP: 'Total Profit (LBP)',
      totalItemsSold: 'Total Items Sold',
      totalSold: 'Total Sold',
      profitUSD: 'Profit (USD)',
      profitLBP: 'Profit (LBP)',
      startDate: 'Start Date',
      endDate: 'End Date',
      applyFilter: 'Apply Filter',
      salesTypeFilter: 'Sales Type',
      allSalesTypes: 'All Sales',
      profitByCategory: 'Profit by Category',
      salesByCategory: 'Sales by Category',
      profitByCurrency: 'Profit by Currency',
      salesByCurrency: 'Sales by Currency',
      salesPercentageByItem: 'Sales Distribution by Item',
      dailySalesChart: 'Daily Sales',
      dailyRevenue: 'Daily Revenue',
      dailySalesCount: 'Daily Sales Count',
      profit: 'Profit',
      exportCSV: 'Export CSV',
      exportSuccess: 'File exported successfully',
      salesChart: 'Sales Chart',
      salesCount: 'Sales Count',
      loading: 'Loading',
      noDataForPeriod: 'No data available for this period',
      invalidDateRange: 'Invalid date range',
      selectDateRange: 'Please select date range',
      errorFetchingReports: 'Error fetching reports',
      errorFetchingItems: 'Error fetching items',
      searchItemsOrBarcode: 'Search by name or scan barcode...',
      addedToCart: 'added to cart',
      itemNotFound: 'Item not found',
      
      // Offline
      offlineWarning: 'You are offline - changes will sync when back online',
      connectionRestored: 'Connection restored - syncing changes',
      pendingChanges: 'Pending changes',
      
      // Public Market Page
      marketNotFound: 'Market not found',
      inStock: 'In Stock',
      outOfStock: 'Out of Stock',
      addToCart: 'Add to Cart',
      addedToCart: 'Added to cart',
      invalidQuantity: 'Invalid quantity',
      continueShopping: 'Continue Shopping',
      newOrder: 'New Order',
      visitStore: 'Visit Store',
      subtotal: 'Subtotal',
      orderViaWhatsApp: 'Order via WhatsApp',
      remainingStock: 'Remaining stock',
      whatsAppOpenedSuccess: 'WhatsApp is opening',
      phoneNumberNotAvailable: 'Phone number not available',
      invalidPhoneNumber: 'Invalid phone number',

      syncingChanges: 'Syncing changes...',
      
      // Receipts
      receipts: 'Receipts',
      searchReceipt: 'Search Receipt',
      receiptNumber: 'Receipt Number',
      enterReceiptNumber: 'Enter receipt number',
      recentReceipts: 'Recent Receipts',
      allReceipts: 'All Receipts',
      debtReceipts: 'Debt Receipts',
      wholesaleReceipts: 'Wholesale Receipts',
      retailReceipts: 'Retail Receipts',
      receiptNotFound: 'Receipt not found',
      receiptUpdated: 'Receipt updated',
      receiptDeleted: 'Receipt deleted',
      errorUpdatingReceipt: 'Error updating receipt',
      errorDeletingReceipt: 'Error deleting receipt',
      confirmDeleteReceipt: 'Are you sure you want to delete this receipt?',
      date: 'Date',
      seller: 'Seller',
      notes: 'Notes',
      enterNotes: 'Enter notes...',
      backToSearch: 'Back to Search',
      saving: 'Saving',
      pleaseEnterReceiptNumber: 'Please enter a receipt number',
      searchByCustomer: 'Search by customer name',
      searchByItem: 'Search by item name',
      fromDate: 'From Date',
      toDate: 'To Date',
      clearFilters: 'Clear Filters',
      allPayments: 'All Payments',
      allInvoices: 'All Invoices',
      editItems: 'Edit Items',
      qty: 'Qty',
      price: 'Price',
      total: 'Total',
      
      // Categories & Brands
      categoriesAndBrands: 'Categories & Brands',
      categories: 'Categories',
      brands: 'Brands',
      addCategory: 'Add Category',
      editCategory: 'Edit Category',
      addBrand: 'Add Brand',
      editBrand: 'Edit Brand',
      selectCategory: 'Select Category',
      selectBrand: 'Select Brand',
      manageCategoriesAndBrands: 'Manage Categories & Brands',
      brand: 'Brand',
      english: 'English',
      deleteConfirm: 'Are you sure you want to delete this?',
      created: 'Created successfully',
      updated: 'Updated successfully',
      deleted: 'Deleted successfully',
      noData: 'No data available',
      
      // Admin Panel
      admin: 'Admin',
      adminPanel: 'Admin Panel',
      manageMarkets: 'Manage all markets and view statistics',
      markets: 'Markets',
      fees: 'Fees',
      market: 'Market',
      addMarket: 'Add New Market',
      createNewMarket: 'Create New Market',
      marketInfo: 'Market Information',
      marketName: 'Market Name',
      enterMarketName: 'Enter market name',
      phone: 'Phone',
      enterPhone: 'Enter phone number',
      email: 'Email',
      enterEmail: 'Enter email address',
      ownerAccount: 'Owner Account',
      username: 'Username',
      enterUsername: 'Enter username',
      password: 'Password',
      enterPassword: 'Enter password',
      language: 'Language',
      createMarket: 'Create Market',
      creating: 'Creating...',
      
      // Manage Users
      manageUsers: 'Manage Users',
      createNewUser: 'Create New User',
      allMarkets: 'All Markets',
      allRoles: 'All Roles',
      filterByMarket: 'Filter by Market',
      filterByRole: 'Filter by Role',
      role: 'Role',
      superadmin: 'Super Admin',
      owner: 'Owner',
      seller: 'Seller',
      status: 'Status',
      dateJoined: 'Date Joined',
      systemWide: 'System-wide',
      noUsersFound: 'No users found',
      fillAllRequiredFields: 'Please fill all required fields',
      passwordTooShort: 'Password must be at least 6 characters',
      userCreatedSuccessfully: 'User created successfully',
      errorCreatingUser: 'Error creating user',
      userStatusUpdated: 'User status updated',
      confirmDeleteUser: 'Are you sure you want to delete this user?',
      userDeletedSuccessfully: 'User deleted successfully',
      errorDeletingUser: 'Error deleting user',
      selectMarket: 'Select Market',
      minPasswordLength: 'Minimum 6 characters',
      deactivate: 'Deactivate',
      activate: 'Activate',
      create: 'Create',
      errorFetchingData: 'Error fetching data',
      marketCreatedSuccessfully: 'Market created successfully',
      errorCreatingMarket: 'Error creating market',
      items: 'Items',
      totalSalesUSD: 'Total Sales (USD)',
      totalSalesLBP: 'Total Sales (LBP)',
      totalProfitUSD: 'Total Profit (USD)',
      totalProfitLBP: 'Total Profit (LBP)',
      fesDue: 'Fees Due',
      users: 'Users',
      established: 'Established',
      status: 'Status',
      amount: 'Amount',
      reason: 'Reason',
      dateCreated: 'Date Created',
      paid: 'Paid',
      pending: 'Pending',
      action: 'Action',
      storeLink: 'Store Link',
      openStore: 'Open Store',
      copyLink: 'Copy Link',
      linkCopied: 'Link copied to clipboard',
      noOwner: 'No owner',
      
      // Images
      addImages: 'Add Images',
      uploadImages: 'Upload Images',
      selectImages: 'Select Images',
      imagesUploaded: 'Images uploaded successfully',
      errorUploadingImages: 'Error uploading images',
      notAnImage: 'is not an image',
      fileTooLarge: 'is too large (max 5MB)',
      dragAndDrop: 'or drag and drop images here',
      imageLimits: 'Max 5MB per image, PNG/JPG',
      uploading: 'Uploading...',
      primary: 'Primary',
      noImages: 'No images',
      
      noFeesFound: 'No fees found',
      feePaidSuccessfully: 'Fee marked as paid successfully',
      errorMarkingFeePaid: 'Error marking fee as paid',
      fillAllFields: 'Please fill all required fields',
      errorFetchingData: 'Error fetching data',
      accessDenied: 'Access denied',
      editMarket: 'Edit Market',
      marketUpdatedSuccess: 'Market updated successfully',
      errorUpdatingMarket: 'Error updating market',

      
      // Debtors (Debt Management)
      debtors: 'Customers',
      debtorsManagement: 'Customers Management',
      title: 'Debt Management',
      addDebtor: 'Add Debtor',
      editDebtor: 'Edit Debtor',
      deleteDebtor: 'Delete Debtor',
      debtorName: 'Debtor Name',
      debtorPhone: 'Debtor Phone',
      debtorDetails: 'Debtor Details',
      totalDebtors: 'Total Debtors',
      totalDebt: 'Total Debt',
      totalPaid: 'Total Paid',
      remaining: 'Remaining',
      remainingDebt: 'Remaining Debt',
      statusPending: 'Pending',
      statusPartial: 'Partial',
      statusPaid: 'Paid',
      allStatus: 'All Status',
      overdue: 'Overdue',
      overdueCount: 'Overdue Count',
      payment: 'Payment',
      paymentAmount: 'Payment Amount',
      recordPayment: 'Record Payment',
      markPaid: 'Mark as Paid',
      paymentRecorded: 'Payment recorded successfully',
      failedToRecordPayment: 'Failed to record payment',
      sendWhatsApp: 'Send WhatsApp',
      whatsappMessage: 'WhatsApp Message',
      whatsappMessagePrepared: 'WhatsApp message prepared - opening WhatsApp',
      failedToSendWhatsApp: 'Failed to send WhatsApp message',
      debtAdded: 'Debtor added successfully',
      debtUpdated: 'Debtor updated successfully',
      debtDeleted: 'Debtor deleted successfully',
      failedToSaveDebtor: 'Failed to save debtor',
      failedToDeleteDebtor: 'Failed to delete debtor',
      failedToFetchDebtors: 'Failed to fetch debtors',
      namePhoneRequired: 'Name and phone are required',
      invalidAmount: 'Please enter a valid amount',
      searchByNameOrPhone: 'Search by name or phone...',
      callDebtor: 'Call debtor',
      debt: 'Debt',
      selectDebtor: 'Select Debtor',
      addNewDebtor: 'Add New Debtor',
    },
    debtors: {
      debtorsManagement: 'Customers Management',
      addDebtor: 'Add Customer',
      editDebtor: 'Edit Customer',
      deleteDebtor: 'Delete Customer',
      name: 'Customer Name',
      phone: 'Customer Phone',
      details: 'Customer Details',
      totalDebtors: 'Total Customers',
      totalDebt: 'Total Debt',
      totalPaid: 'Total Paid',
      remaining: 'Remaining',
      remainingDebt: 'Remaining Debt',
      status: 'Status',
      statusPending: 'Pending',
      statusPartial: 'Partial',
      statusPaid: 'Paid',
      allStatus: 'All Status',
      overdue: 'Overdue',
      overdueCount: 'Overdue Count',
      payment: 'Payment',
      paymentAmount: 'Payment Amount',
      recordPayment: 'Record Payment',
      markPaid: 'Mark as Paid',
      paymentRecorded: 'Payment recorded successfully',
      failedToRecordPayment: 'Failed to record payment',
      sendWhatsApp: 'Send WhatsApp',
      whatsappMessage: 'WhatsApp Message',
      whatsappMessagePrepared: 'WhatsApp message prepared - opening WhatsApp',
      failedToSendWhatsApp: 'Failed to send WhatsApp message',
      debtAdded: 'Customer added successfully',
      debtUpdated: 'Customer updated successfully',
      debtDeleted: 'Customer deleted successfully',
      failedToSaveDebtor: 'Failed to save customer',
      failedToDeleteDebtor: 'Failed to delete customer',
      cannotDeleteCustomerWithInvoices: 'Cannot delete customer with invoices',
      failedToFetchDebtors: 'Failed to fetch customers',
      namePhoneRequired: 'Name and phone are required',
      invalidAmount: 'Please enter a valid amount',
      searchByNameOrPhone: 'Search by name or phone...',
      callDebtor: 'Call customer',
      debtorName: 'Customer Name',
      debtorPhone: 'Customer Phone',
      debtorDetails: 'Customer Details',
      viewDetails: 'View Details',
      customerStatistics: 'Customer Statistics',
      accountStatement: 'Account Statement',
      paymentHistory: 'Payment History',
      statementGeneratedAt: 'Generated at',
      failedToLoadStatement: 'Failed to load statement',
      noDataAvailable: 'No data available',
      receiptNumber: 'Receipt Number',
      totalInvoices: 'Total Invoices',
      debtInvoices: 'Debt Invoices',
      totalSalesUSD: 'Total Sales (USD)',
      totalSalesLBP: 'Total Sales (LBP)',
      debtUSD: 'Debt (USD)',
      debtLBP: 'Debt (LBP)',
      salesInfo: 'Sales Information',
      debtInfo: 'Debt Information',
      
      // Wholesale/Box Selling
      wholesale: 'Wholesale',
      retail: 'Retail',
      wholesaleSales: 'Wholesale Sales',
      retailSales: 'Retail Sales',
      wholesaleInvoice: 'Wholesale Invoice',
      sellWholeBox: 'Sell Whole Box',
      sellwollbox: 'Sell Whole Box',
      sellwellbox: 'Sell Whole Box',
      wholeBoxAdded: 'Whole box added: {{item}}',
      batchNotFull: 'Cannot sell whole box - batch is not full',
      batchnotfull: 'Cannot sell whole box - batch is not full',
      noBatchAvailable: 'No batch available for this item',
      insufficientStockForBox: 'Insufficient stock for a whole box',
      noBoxPriceSet: 'Box price not set for this batch',
      errorAddingBox: 'Error adding whole box to cart',
    }
  },
  ar: {
    translation: {
      // Auth
      login: 'تسجيل الدخول',
      register: 'تسجيل',
      logout: 'تسجيل الخروج',
      username: 'اسم المستخدم',
      password: 'كلمة المرور',
      marketName: 'اسم المتجر',
      selectLanguage: 'اختر اللغة',
      signIn: 'تسجيل الدخول',
      signUp: 'إنشاء حساب',
      dontHaveAccount: 'ليس لديك حساب؟',
      alreadyHaveAccount: 'لديك حساب بالفعل؟',
      
      // Dashboard
      dashboard: 'لوحة التحكم',
      welcome: 'مرحبا',
      totalItems: 'إجمالي العناصر',
      lowStockItems: 'عناصر منخفضة المخزون',
      totalValue: 'القيمة الإجمالية للمخزون',
      totalValueBuying: 'القيمة الإجمالية للمخزون (شراء)',
      totalValueSelling: 'القيمة الإجمالية للمخزون (بيع)',
      recentItems: 'العناصر الأخيرة',
      noStock: 'لا مخزون',
      
      // Items
      items: 'العناصر',
      addItem: 'إضافة عنصر',
      editItem: 'تعديل العنصر',
      deleteItem: 'حذف العنصر',
      toggleItemStatus: 'تغيير حالة العنصر',
      deactivateItem: 'تجميد العنصر',
      activateItem: 'تفعيل العنصر',
      itemDeactivated: 'تم تجميد العنصر بنجاح',
      itemActivated: 'تم تفعيل العنصر بنجاح',
      frozenItems: 'العناصر المجمدة',
      sellingPriceLowerWarning: 'تحذير: سعر البيع أقل من سعر الشراء',
      expiryBeforeProductionError: 'يجب أن يكون تاريخ الانتهاء بعد تاريخ الإنتاج',
      cannotDeactivateItemWithStock: 'لا يمكن تجميد عنصر فيه مخزون. يجب أن يكون المخزون صفر.',
      cannotDeleteCategoryWithItems: 'لا يمكن حذف الفئة لوجود عناصر مرتبطة',
      cannotDeleteBrandWithItems: 'لا يمكن حذف العلامة لوجود عناصر مرتبطة',
      cannotDeleteItemWithBatches: 'لا يمكن حذف العنصر لوجود صناديق مرتبطة',
      cannotDeleteItemWithSales: 'لا يمكن حذف العنصر لوجود صناديق مباعة',
      cannotDeleteBatchWithSales: 'لا يمكن حذف الصندوق لوجود فواتير مرتبطة',
      itemName: 'اسم العنصر',
      description: 'الوصف',
      barcode: 'الباركود',
      sku: 'رمز المنتج',
      buyingPrice: 'سعر الشراء',
      sellingPrice: 'سعر البيع',
      currency: 'العملة',
      lbp: 'ليرة لبنانية (ل.ل)',
      usd: 'دولار أمريكي ($)',
      lbpSymbol: 'ل.ل',
      usdSymbol: '$',
      exchangeRate: 'سعر الصرف',
      generalExchangeRate: 'سعر الصرف العام (1 دولار = X ل.ل)',
      customExchangeRate: 'سعر صرف خاص (اختياري)',
      updateExchangeRate: 'تحديث سعر الصرف',
      exchangeRateUpdated: 'تم تحديث سعر الصرف بنجاح',
      updatePhone: 'تحديث رقم الهاتف',
      currentPhone: 'الرقم الحالي',
      notSet: 'غير محدد',
      languageUpdated: 'تم تحديث اللغة بنجاح',
      quantity: 'الكمية',
      category: 'الفئة',
      lowStockThreshold: 'حد المخزون المنخفض',
      profitMargin: 'هامش الربح',
      active: 'نشط',
      inactive: 'غير نشط',
      save: 'حفظ',
      cancel: 'إلغاء',
      search: 'بحث',
      filter: 'تصفية',
      
      // Batches
      batch: 'صندوق',
      batches: 'صناديق',
      addBatch: 'إضافة صندوق',
      editBatch: 'تعديل الصندوق',
      batchCode: 'كود الصندوق',
      batchBarcode: 'باركود الصندوق',
      numberOfBoxes: 'عدد الصناديق',
      itemsPerBox: 'عدد العناصر في الصندوق',
      boxBuyingPrice: 'سعر شراء الصندوق',
      boxSellingPrice: 'سعر بيع الصندوق',
      unitBuyingPrice: 'سعر شراء العنصر',
      unitSellingPrice: 'سعر بيع العنصر',
      calculated: 'محسوب تلقائياً',
      autoCalculatedFromBox: 'يُحتسب تلقائياً من سعر الصندوق، يمكن تعديله',
      totalBatchQuantity: 'الكمية الإجمالية في الصندوق',
      items: 'عناصر',
      productionDate: 'تاريخ الإنتاج',
      expiryDate: 'تاريخ انتهاء الصلاحية',
      exp: 'انتهاء',
      alertDays: 'مدة الانذار (أيام قبل الانتهاء)',
      daysUntilExpiry: 'الأيام المتبقية',
      expiringBatches: 'الصناديق قريبة انتهاء الصلاحية',
      expiredBatches: 'الصناديق منتهية الصلاحية',
      batchStatus: 'حالة الصندوق',
      ok: 'جيد',
      alert: 'تحذير',
      expired: 'منتهي الصلاحية',
      batchAddedSuccess: 'تمت إضافة الصندوق بنجاح',
      batchUpdatedSuccess: 'تم تحديث الصندوق بنجاح',
      batchDeletedSuccess: 'تم حذف الصندوق بنجاح',
      cannotEditBatchCode: 'لا يمكن تعديل رقم الصندوق بعد إنشائه',
      updateBatch: 'تحديث الصندوق',
      cancelEdit: 'إلغاء التعديل',
      noBatches: 'لا توجد صناديق لهذا العنصر',
      atLeastOneBatch: 'يجب إضافة صندوق واحد على الأقل',
      totalItems: 'الكمية الإجمالية',
      addedBatches: 'الصناديق المضافة',
      noBatchCode: 'بدون كود',
      boxes: 'صندوق/صناديق',
      unit: 'عنصر',
      numberOfBatches: 'عدد الصناديق',
      totalQuantity: 'الكمية الإجمالية',
      totalBoxes: 'إجمالي الصناديق',
      
      // Messages
      loginSuccess: 'تم تسجيل الدخول بنجاح',
      loginError: 'بيانات الاعتماد غير صالحة',
      registerSuccess: 'تم التسجيل بنجاح',
      itemAddedSuccess: 'تمت إضافة العنصر بنجاح',
      itemUpdatedSuccess: 'تم تحديث العنصر بنجاح',
      itemDeletedSuccess: 'تم حذف العنصر بنجاح',
      error: 'حدث خطأ',
      
      // Common
      yes: 'نعم',
      no: 'لا',
      delete: 'حذف',
      edit: 'تعديل',
      view: 'عرض',
      actions: 'الإجراءات',
      
      // POS
      pos: 'نقطة البيع',
      cart: 'السلة',
      cartEmpty: 'السلة فارغة',
      searchItems: 'ابحث عن العناصر...',
      searchItemsOrBarcode: 'ابحث بالاسم أو امسح الباركود...',
      addedToCart: 'تمت الإضافة للسلة',
      itemNotFound: 'العنصر غير موجود',
      invalidItem: 'عنصر غير صالح',
      noPriceSet: 'لا يوجد سعر',
      stock: 'المخزون',
      checkout: 'إتمام الشراء',
      paymentMethod: 'طريقة الدفع',
      cash: 'نقدي',
      card: 'بطاقة',
      both: 'كلاهما',
      bothCurrency: 'دولار + لبناني',
      debt: 'دين',
      customer: 'الزبون',
      addCustomer: 'إضافة زبون',
      selectCustomer: 'اختر زبون',
      selectCustomerForDebt: 'يجب اختيار زبون للدفع بالدين',
      customerName: 'اسم الزبون',
      customerPhone: 'هاتف الزبون',
      remainingDebt: 'الدين المتبقي',
      receipt: 'الفاتورة',
      print: 'طباعة',
      generatedOn: 'تم الإنشاء في',
      newSale: 'بيع جديد',
      thankYou: 'شكراً لشرائك!',
      saleCompleted: 'تمت عملية البيع بنجاح',
      errorCreatingSale: 'خطأ في إنشاء عملية البيع',
      insufficientStock: 'المخزون غير كافٍ',
      totalUSD: 'المجموع (دولار)',
      totalLBP: 'المجموع (ل.ل)',
      qty: 'الكمية',
      price: 'السعر',
      total: 'المجموع',
      item: 'العنصر',
      back: 'رجوع',
      sold: 'تم بيعه',
      popularItems: 'العناصر الشهيرة',
      allItems: 'جميع العناصر',
      noItems: 'لا توجد عناصر متاحة',
      refresh: 'تحديث',
      totalSales: 'إجمالي المبيعات',
      convertedTo: 'محول إلى',
      grandTotal: 'المجموع الكلي',
      
      // Unit Types & Measurements
      unitType: 'نوع الوحدة',
      unitTypeHint: 'اختر كيفية قياس/بيع هذا العنصر',
      unitTypeQuantity: 'الكمية (قطع)',
      unitTypeWeight: 'الوزن (كغ)',
      unitTypeLength: 'الطول (م)',
      unitTypeArea: 'المساحة (م²)',
      unitTypeVolume: 'الحجم (لتر)',
      allowFractional: 'السماح بكميات عشرية',
      allowFractionalHint: 'السماح بقيم كسرية مثل 0.5، 1.25، 2.75',
      weightKg: 'الوزن (كغ)',
      lengthM: 'الطول (م)',
      areaM2: 'المساحة (م²)',
      volumeL: 'الحجم (لتر)',
      kg: 'كغ',
      meter: 'م',
      squareMeter: 'م²',
      liter: 'لتر',
      pieces: 'قطع',
      enterWeight: 'أدخل الوزن',
      enterLength: 'أدخل الطول',
      enterArea: 'أدخل المساحة',
      enterVolume: 'أدخل الحجم',
      enterValidMeasurement: 'الرجاء إدخال قياس صحيح',
      availableQuantity: 'متوفر',
      confirm: 'تأكيد',
      
      // Reports
      reports: 'التقارير',
      profitsAndReports: 'الأرباح والتقارير',
      profitByItem: 'الربح حسب العنصر',
      totalProfitUSD: 'إجمالي الربح (دولار)',
      totalProfitLBP: 'إجمالي الربح (ل.ل)',
      totalItemsSold: 'إجمالي العناصر المباعة',
      totalSold: 'المباع الكلي',
      profitUSD: 'الربح (دولار)',
      profitLBP: 'الربح (ل.ل)',
      startDate: 'تاريخ البداية',
      endDate: 'تاريخ النهاية',
      applyFilter: 'تطبيق الفلتر',
      salesTypeFilter: 'نوع المبيعات',
      allSalesTypes: 'كل المبيعات',
      profitByCategory: 'الربح حسب الفئة',
      salesByCategory: 'المبيعات حسب الفئة',
      profitByCurrency: 'الربح حسب العملة',
      salesByCurrency: 'المبيعات حسب العملة',
      salesPercentageByItem: 'توزيع المبيعات حسب العنصر',
      dailySalesChart: 'المبيعات اليومية',
      dailyRevenue: 'الإيرادات اليومية',
      dailySalesCount: 'عدد المبيعات اليومية',
      profit: 'الربح',
      totalSold: 'المباع',
      profitUSD: 'الربح (دولار)',
      profitLBP: 'الربح (ل.ل)',
      startDate: 'تاريخ البداية',
      endDate: 'تاريخ النهاية',
      applyFilter: 'تطبيق الفلتر',
      exportCSV: 'تصدير CSV',
      exportSuccess: 'تم تصدير الملف بنجاح',
      salesChart: 'مخطط المبيعات',
      salesCount: 'عدد المبيعات',
      loading: 'جارٍ التحميل',
      noDataForPeriod: 'لا توجد بيانات لهذه الفترة',
      invalidDateRange: 'نطاق التاريخ غير صالح',
      selectDateRange: 'الرجاء اختيار نطاق التاريخ',
      errorFetchingReports: 'خطأ في جلب التقارير',
      errorFetchingItems: 'خطأ في جلب العناصر',
      
      // Offline
      offlineWarning: 'أنت غير متصل - سيتم مزامنة التغييرات عند الاتصال',
      connectionRestored: 'تم استعادة الاتصال - جاري المزامنة',
      pendingChanges: 'تغييرات معلقة',
      syncingChanges: 'جاري المزامنة...',
      
      // صفحة المحل العام
      marketNotFound: 'المحل غير موجود',
      inStock: 'متوفر',
      outOfStock: 'غير متوفر',
      addToCart: 'إضافة للسلة',
      addedToCart: 'تمت الإضافة للسلة',
      invalidQuantity: 'كمية غير صحيحة',
      continueShopping: 'متابعة التسوق',
      newOrder: 'طلب جديد',
      visitStore: 'زيارة المحل',
      subtotal: 'المجموع الجزئي',
      orderViaWhatsApp: 'طلب عبر واتساب',
      remainingStock: 'المتبقي في المخزون',
      whatsAppOpenedSuccess: 'واتساب سيفتح الآن',
      phoneNumberNotAvailable: 'رقم الهاتف غير متوفر',
      invalidPhoneNumber: 'رقم هاتف غير صحيح',
      
      // Receipts
      receipts: 'الفواتير',
      searchReceipt: 'ابحث عن الفاتورة',
      receiptNumber: 'رقم الفاتورة',
      enterReceiptNumber: 'أدخل رقم الفاتورة',
      recentReceipts: 'الفواتير الأخيرة',
      allReceipts: 'جميع الفواتير',
      debtReceipts: 'فواتير الدين',
      wholesaleReceipts: 'فواتير الجملة',
      retailReceipts: 'فواتير المفرق',
      receiptNotFound: 'الفاتورة غير موجودة',
      receiptUpdated: 'تم تحديث الفاتورة',
      receiptDeleted: 'تم حذف الفاتورة',
      errorUpdatingReceipt: 'خطأ في تحديث الفاتورة',
      errorDeletingReceipt: 'خطأ في حذف الفاتورة',
      confirmDeleteReceipt: 'هل أنت متأكد من حذف هذه الفاتورة؟',
      date: 'التاريخ',
      seller: 'البائع',
      notes: 'ملاحظات',
      enterNotes: 'أدخل ملاحظات...',
      backToSearch: 'العودة للبحث',
      saving: 'جارٍ الحفظ',
      pleaseEnterReceiptNumber: 'يرجى إدخال رقم الفاتورة',
      searchByCustomer: 'البحث باسم الزبون',
      searchByItem: 'البحث حسب العنصر',
      fromDate: 'من تاريخ',
      toDate: 'إلى تاريخ',
      clearFilters: 'مسح الفلاتر',
      allPayments: 'جميع طرق الدفع',
      allInvoices: 'جميع الفواتير',
      editItems: 'تعديل العناصر',
      qty: 'الكمية',
      price: 'السعر',
      total: 'الإجمالي',
      
      // Categories & Brands
      categoriesAndBrands: 'الفئات والماركات',
      categories: 'الفئات',
      brands: 'الماركات',
      addCategory: 'إضافة فئة',
      editCategory: 'تعديل الفئة',
      addBrand: 'إضافة ماركة',
      editBrand: 'تعديل الماركة',
      selectCategory: 'اختر فئة',
      selectBrand: 'اختر ماركة',
      manageCategoriesAndBrands: 'إدارة الفئات والماركات',
      brand: 'الماركة',
      english: 'English',
      deleteConfirm: 'هل أنت متأكد من حذف هذا العنصر؟',
      created: 'تم الإنشاء بنجاح',
      updated: 'تم التحديث بنجاح',
      deleted: 'تم الحذف بنجاح',
      noData: 'لا توجد بيانات متاحة',
      
      // لوحة التحكم
      admin: 'إدارة النظام',
      adminPanel: 'لوحة التحكم',
      manageMarkets: 'إدارة جميع المتاجر وعرض الإحصائيات',
      markets: 'المتاجر',
      fees: 'الرسوم',
      market: 'المتجر',
      addMarket: 'إضافة متجر جديد',
      createNewMarket: 'إنشاء متجر جديد',
      marketInfo: 'معلومات المتجر',
      marketName: 'اسم المتجر',
      enterMarketName: 'أدخل اسم المتجر',
      phone: 'الهاتف',
      enterPhone: 'أدخل رقم الهاتف',
      email: 'البريد الإلكتروني',
      enterEmail: 'أدخل البريد الإلكتروني',
      ownerAccount: 'حساب المالك',
      username: 'اسم المستخدم',
      enterUsername: 'أدخل اسم المستخدم',
      password: 'كلمة المرور',
      enterPassword: 'أدخل كلمة المرور',
      language: 'اللغة',
      createMarket: 'إنشاء المتجر',
      creating: 'جاري الإنشاء...',
      
      // إدارة المستخدمين
      manageUsers: 'إدارة المستخدمين',
      createNewUser: 'إضافة مستخدم جديد',
      allMarkets: 'جميع المحلات',
      allRoles: 'جميع الصلاحيات',
      filterByMarket: 'فلترة حسب المحل',
      filterByRole: 'فلترة حسب الصلاحية',
      role: 'الصلاحية',
      superadmin: 'مدير أعلى',
      owner: 'مالك',
      systemWide: 'النظام كامل',
      noUsersFound: 'لا يوجد مستخدمين',
      fillAllRequiredFields: 'يرجى ملء جميع الحقول المطلوبة',
      passwordTooShort: 'كلمة المرور يجب أن تكون 6 أحرف على الأقل',
      userCreatedSuccessfully: 'تم إنشاء المستخدم بنجاح',
      errorCreatingUser: 'خطأ في إنشاء المستخدم',
      userStatusUpdated: 'تم تحديث حالة المستخدم',
      confirmDeleteUser: 'هل أنت متأكد من حذف هذا المستخدم؟',
      userDeletedSuccessfully: 'تم حذف المستخدم بنجاح',
      errorDeletingUser: 'خطأ في حذف المستخدم',
      selectMarket: 'اختر المحل',
      minPasswordLength: 'الحد الأدنى 6 أحرف',
      deactivate: 'تعطيل',
      activate: 'تفعيل',
      create: 'إنشاء',
      dateJoined: 'تاريخ الانضمام',
      
      marketCreatedSuccessfully: 'تم إنشاء المتجر بنجاح',
      errorCreatingMarket: 'خطأ في إنشاء المتجر',
      items: 'العناصر',
      totalSalesUSD: 'إجمالي المبيعات (دولار)',
      totalSalesLBP: 'إجمالي المبيعات (ل.ل)',
      totalProfitUSD: 'إجمالي الربح (دولار)',
      totalProfitLBP: 'إجمالي الربح (ل.ل)',
      fesDue: 'الرسوم المستحقة',
      users: 'المستخدمون',
      established: 'تاريخ التأسيس',
      status: 'الحالة',
      amount: 'المبلغ',
      reason: 'السبب',
      dateCreated: 'تاريخ الإنشاء',
      paid: 'مدفوع',
      pending: 'قيد الانتظار',
      action: 'الإجراء',
      storeLink: 'رابط المتجر',
      openStore: 'فتح المتجر',
      copyLink: 'نسخ الرابط',
      linkCopied: 'تم نسخ الرابط',
      noOwner: 'لا يوجد مالك',
      
      // الصور
      addImages: 'إضافة صور',
      uploadImages: 'تحميل الصور',
      selectImages: 'اختر الصور',
      imagesUploaded: 'تم تحميل الصور بنجاح',
      errorUploadingImages: 'خطأ في تحميل الصور',
      notAnImage: 'ليست صورة',
      fileTooLarge: 'ملف كبير جداً (الحد الأقصى 5MB)',
      dragAndDrop: 'أو اسحب وأفلت الصور هنا',
      imageLimits: 'الحد الأقصى 5MB لكل صورة، PNG/JPG',
      uploading: 'جاري التحميل...',
      primary: 'الرئيسية',
      noImages: 'لا توجد صور',
      
      noFeesFound: 'لم يتم العثور على رسوم',
      feePaidSuccessfully: 'تم وضع علامة على الرسم كمدفوع بنجاح',
      errorMarkingFeePaid: 'خطأ في وضع علامة على الرسم كمدفوع',
      fillAllFields: 'يرجى ملء جميع الحقول المطلوبة',
      errorFetchingData: 'خطأ في جلب البيانات',
      accessDenied: 'تم رفع الوصول',
      editMarket: 'تعديل المتجر',
      marketUpdatedSuccess: 'تم تحديث المتجر بنجاح',
      errorUpdatingMarket: 'خطأ في تحديث المتجر',

      
      // الديون (إدارة الديون)
      debtors: 'الزبائن',
      debtorsManagement: 'إدارة الزبائن',
      title: 'إدارة الديون',
      addDebtor: 'إضافة دائن',
      editDebtor: 'تعديل الدائن',
      deleteDebtor: 'حذف الدائن',
      debtorName: 'اسم الدائن',
      debtorPhone: 'هاتف الدائن',
      debtorDetails: 'تفاصيل الدائن',
      totalDebtors: 'إجمالي الدائنين',
      totalDebt: 'إجمالي الديون',
      totalPaid: 'المبلغ المدفوع',
      remaining: 'المتبقي',
      remainingDebt: 'الدين المتبقي',
      statusPending: 'قيد الانتظار',
      statusPartial: 'جزئي',
      statusPaid: 'مدفوع',
      allStatus: 'جميع الحالات',
      overdue: 'متأخر',
      overdueCount: 'عدد المتأخرين',
      payment: 'دفع',
      paymentAmount: 'مبلغ الدفع',
      recordPayment: 'تسجيل الدفع',
      markPaid: 'وضع علامة كمدفوع',
      paymentRecorded: 'تم تسجيل الدفع بنجاح',
      failedToRecordPayment: 'فشل تسجيل الدفع',
      sendWhatsApp: 'إرسال واتس آب',
      whatsappMessage: 'رسالة واتس آب',
      whatsappMessagePrepared: 'تم تحضير رسالة واتس آب - جاري فتح التطبيق',
      failedToSendWhatsApp: 'فشل إرسال رسالة واتس آب',
      debtAdded: 'تمت إضافة الدائن بنجاح',
      debtUpdated: 'تم تحديث الدائن بنجاح',
      debtDeleted: 'تم حذف الدائن بنجاح',
      failedToSaveDebtor: 'فشل حفظ الدائن',
      failedToDeleteDebtor: 'فشل حذف الدائن',
      failedToFetchDebtors: 'فشل جلب الدائنين',
      namePhoneRequired: 'الاسم والهاتف مطلوبان',
      invalidAmount: 'يرجى إدخال مبلغ صحيح',
      searchByNameOrPhone: 'ابحث بالاسم أو الهاتف...',
      callDebtor: 'اتصل بالدائن',
      debt: 'دين',
      selectDebtor: 'اختر دائن',
      addNewDebtor: 'إضافة دائن جديد',
    },
    debtors: {
      debtorsManagement: 'إدارة الزبائن',
      addDebtor: 'إضافة زبون',
      editDebtor: 'تعديل الزبون',
      deleteDebtor: 'حذف الزبون',
      name: 'اسم الزبون',
      phone: 'هاتف الزبون',
      details: 'تفاصيل الزبون',
      totalDebtors: 'إجمالي الزبائن',
      totalDebt: 'إجمالي الديون',
      totalPaid: 'المبلغ المدفوع',
      remaining: 'المتبقي',
      remainingDebt: 'الدين المتبقي',
      status: 'الحالة',
      statusPending: 'قيد الانتظار',
      statusPartial: 'جزئي',
      statusPaid: 'مدفوع',
      allStatus: 'جميع الحالات',
      overdue: 'متأخر',
      overdueCount: 'عدد المتأخرين',
      payment: 'دفع',
      paymentAmount: 'مبلغ الدفع',
      recordPayment: 'تسجيل الدفع',
      markPaid: 'وضع علامة كمدفوع',
      paymentRecorded: 'تم تسجيل الدفع بنجاح',
      failedToRecordPayment: 'فشل تسجيل الدفع',
      sendWhatsApp: 'إرسال واتس آب',
      whatsappMessage: 'رسالة واتس آب',
      whatsappMessagePrepared: 'تم تحضير رسالة واتس آب - جاري فتح التطبيق',
      failedToSendWhatsApp: 'فشل إرسال رسالة واتس آب',
      debtAdded: 'تمت إضافة الزبون بنجاح',
      debtUpdated: 'تم تحديث الزبون بنجاح',
      debtDeleted: 'تم حذف الزبون بنجاح',
      failedToSaveDebtor: 'فشل حفظ الزبون',
      failedToDeleteDebtor: 'فشل حذف الزبون',
      cannotDeleteCustomerWithInvoices: 'لا يمكن حذف زبون عليه فواتير',
      failedToFetchDebtors: 'فشل جلب الزبائن',
      namePhoneRequired: 'الاسم والهاتف مطلوبان',
      invalidAmount: 'يرجى إدخال مبلغ صحيح',
      searchByNameOrPhone: 'ابحث بالاسم أو الهاتف...',
      callDebtor: 'اتصل بالزبون',
      debtorName: 'اسم الزبون',
      debtorPhone: 'هاتف الزبون',
      debtorDetails: 'تفاصيل الزبون',
      viewDetails: 'عرض التفاصيل',
      customerStatistics: 'إحصائيات الزبون',
      accountStatement: 'كشف حساب',
      paymentHistory: 'سجل الدفعات',
      statementGeneratedAt: 'تاريخ الطباعة',
      failedToLoadStatement: 'فشل تحميل كشف الحساب',
      noDataAvailable: 'لا توجد بيانات',
      receiptNumber: 'رقم الفاتورة',
      totalInvoices: 'إجمالي الفواتير',
      debtInvoices: 'فواتير الدين',
      totalSalesUSD: 'إجمالي المبيعات (دولار)',
      totalSalesLBP: 'إجمالي المبيعات (ليرة)',
      debtUSD: 'الدين (دولار)',
      debtLBP: 'الدين (ليرة)',
      salesInfo: 'معلومات المبيعات',
      debtInfo: 'معلومات الديون',
      
      // Wholesale/Box Selling
      wholesale: 'جملة',
      retail: 'مفرق',
      wholesaleSales: 'مبيعات الجملة',
      retailSales: 'مبيعات المفرق',
      wholesaleInvoice: 'فاتورة جملة',
      sellWholeBox: 'بيع صندوق كامل',
      sellwollbox: 'بيع صندوق كامل',
      sellwellbox: 'بيع صندوق كامل',
      wholeBoxAdded: 'تمت إضافة صندوق: {{item}}',
      batchNotFull: 'لا يمكن بيع الصندوق كاملاً - الصندوق ناقص',
      batchnotfull: 'لا يمكن بيع الصندوق كاملاً - الصندوق ناقص',
      noBatchAvailable: 'لا يوجد صندوق متاح لهذا العنصر',
      insufficientStockForBox: 'المخزون غير كافٍ لصندوق كامل',
      noBoxPriceSet: 'سعر الصندوق غير محدد لهذا الصندوق',
      errorAddingBox: 'خطأ في إضافة الصندوق الكامل',
    }
  },
  fr: {
    translation: {
      // Auth
      login: 'Connexion',
      register: 'Inscription',
      logout: 'Déconnexion',
      username: "Nom d'utilisateur",
      password: 'Mot de passe',
      marketName: 'Nom du marché',
      selectLanguage: 'Sélectionner la langue',
      signIn: 'Se connecter',
      signUp: "S'inscrire",
      dontHaveAccount: "Vous n'avez pas de compte?",
      alreadyHaveAccount: 'Vous avez déjà un compte?',
      
      // Dashboard
      dashboard: 'Tableau de bord',
      welcome: 'Bienvenue',
      totalItems: 'Total des articles',
      lowStockItems: 'Articles en stock faible',
      totalValue: "Valeur totale de l'inventaire",
      totalValueBuying: "Valeur totale de l'inventaire (Achat)",
      totalValueSelling: "Valeur totale de l'inventaire (Vente)",
      recentItems: 'Articles récents',
      noStock: 'Aucun stock',
      
      // Items
      items: 'Articles',
      addItem: 'Ajouter un article',
      editItem: "Modifier l'article",
      deleteItem: "Supprimer l'article",
      toggleItemStatus: "Changer l'état de l'article",
      deactivateItem: "Désactiver l'article",
      activateItem: "Activer l'article",
      itemDeactivated: "Article désactivé avec succès",
      itemActivated: "Article activé avec succès",
      frozenItems: 'Articles gelés',
      sellingPriceLowerWarning: "Avertissement : le prix de vente est inférieur au prix d'achat",
      expiryBeforeProductionError: "La date d'expiration doit être après la date de production",
      cannotDeactivateItemWithStock: "Impossible de désactiver un article avec du stock. Le stock doit être zéro.",
      cannotDeleteCategoryWithItems: 'Impossible de supprimer une catégorie avec des articles',
      cannotDeleteBrandWithItems: 'Impossible de supprimer une marque avec des articles',
      cannotDeleteItemWithBatches: "Impossible de supprimer l'article avec des lots",
      cannotDeleteItemWithSales: "Impossible de supprimer l'article avec des lots vendus",
      cannotDeleteBatchWithSales: 'Impossible de supprimer un lot vendu',
      itemName: "Nom de l'article",
      description: 'Description',
      barcode: 'Code-barres',
      currency: 'Devise',
      lbp: 'Livre libanaise (L.L)',
      usd: 'Dollar américain ($)',
      lbpSymbol: 'L.L',
      usdSymbol: '$',
      exchangeRate: 'Taux de change',
      generalExchangeRate: 'Taux de change général (1 USD = X LBP)',
      customExchangeRate: 'Taux de change personnalisé (Optionnel)',
      updateExchangeRate: 'Mettre à jour le taux de change',
      exchangeRateUpdated: 'Taux de change mis à jour avec succès',
      updatePhone: 'Mettre à jour le numéro de téléphone',
      currentPhone: 'Téléphone actuel',
      notSet: 'Non défini',
      languageUpdated: 'Langue mise à jour avec succès',
      sku: 'SKU',
      buyingPrice: "Prix d'achat",
      sellingPrice: 'Prix de vente',
      quantity: 'Quantité',
      category: 'Catégorie',
      lowStockThreshold: 'Seuil de stock faible',
      profitMargin: 'Marge bénéficiaire',
      active: 'Actif',
      inactive: 'Inactif',
      save: 'Enregistrer',
      cancel: 'Annuler',
      search: 'Rechercher',
      filter: 'Filtrer',
      
      // Batches
      batch: 'Lot',
      batches: 'Lots',
      addBatch: 'Ajouter un lot',
      editBatch: 'Modifier le lot',
      batchCode: 'Code du lot',
      batchBarcode: 'Code-barres du lot',
      numberOfBoxes: 'Nombre de boîtes',
      itemsPerBox: 'Articles par boîte',
      boxBuyingPrice: 'Prix d\'achat de la boîte',
      boxSellingPrice: 'Prix de vente de la boîte',
      unitBuyingPrice: 'Prix d\'achat unitaire',
      unitSellingPrice: 'Prix de vente unitaire',
      calculated: 'Calculé automatiquement',
      autoCalculatedFromBox: 'Calculé automatiquement à partir du prix de la boîte, modifiable',
      totalBatchQuantity: 'Quantité totale du lot',
      items: 'articles',
      productionDate: 'Date de production',
      expiryDate: 'Date d\'expiration',
      exp: 'Exp',
      alertDays: 'Jours d\'alerte (avant expiration)',
      daysUntilExpiry: 'Jours restants',
      expiringBatches: 'Lots proches de l\'expiration',
      expiredBatches: 'Lots expirés',
      batchStatus: 'État du lot',
      ok: 'OK',
      alert: 'Alerte',
      expired: 'Expiré',
      batchAddedSuccess: 'Lot ajouté avec succès',
      batchUpdatedSuccess: 'Lot mis à jour avec succès',
      batchDeletedSuccess: 'Lot supprimé avec succès',
      updateBatch: 'Mettre à jour le lot',
      cancelEdit: 'Annuler l’édition',
      noBatches: 'Aucun lot pour cet article',
      atLeastOneBatch: 'Au moins un lot est requis',
      totalItems: 'Total des articles',
      addedBatches: 'Lots ajoutés',
      noBatchCode: 'Sans code',
      boxes: 'boîte(s)',
      unit: 'unité',
      numberOfBatches: 'Nombre de lots',
      totalQuantity: 'Quantité totale',
      totalBoxes: 'Total des boîtes',
      
      // Messages
      loginSuccess: 'Connexion réussie',
      loginError: 'Identifiants invalides',
      registerSuccess: 'Inscription réussie',
      itemAddedSuccess: 'Article ajouté avec succès',
      itemUpdatedSuccess: 'Article mis à jour avec succès',
      itemDeletedSuccess: 'Article supprimé avec succès',
      error: "Une erreur s'est produite",
      
      // Common
      yes: 'Oui',
      no: 'Non',
      delete: 'Supprimer',
      edit: 'Modifier',
      view: 'Voir',
      actions: 'Actions',
      
      // POS
      pos: 'Point de vente',
      cart: 'Panier',
      cartEmpty: 'Le panier est vide',
      searchItems: 'Rechercher des articles...',
      searchItemsOrBarcode: 'Rechercher par nom ou scanner le code-barres...',
      addedToCart: 'ajouté au panier',
      itemNotFound: 'Article non trouvé',
      invalidItem: 'Article invalide',
      noPriceSet: 'Aucun prix défini',
      stock: 'Stock',
      checkout: 'Payer',
      paymentMethod: 'Mode de paiement',
      cash: 'Espèces',
      card: 'Carte',
      both: 'Les deux',
      bothCurrency: 'USD + LBP',
      debt: 'Crédit',
      customer: 'Client',
      addCustomer: 'Ajouter un client',
      selectCustomer: 'Sélectionner un client',
      selectCustomerForDebt: 'Client requis pour paiement à crédit',
      customerName: 'Nom du client',
      customerPhone: 'Téléphone du client',
      remainingDebt: 'Crédit restant',
      receipt: 'Reçu',
      print: 'Imprimer',
      generatedOn: 'Généré le',
      newSale: 'Nouvelle vente',
      thankYou: 'Merci pour votre achat!',
      saleCompleted: 'Vente terminée avec succès',
      errorCreatingSale: 'Erreur lors de la création de la vente',
      insufficientStock: 'Stock insuffisant',
      totalUSD: 'Total (USD)',
      totalLBP: 'Total (LBP)',
      qty: 'Qté',
      price: 'Prix',
      total: 'Total',
      item: 'Article',
      back: 'Retour',
      sold: 'Vendu',
      popularItems: 'Articles populaires',
      allItems: 'Tous les articles',
      noItems: 'Aucun article disponible',
      refresh: 'Actualiser',
      totalSales: 'Ventes totales',
      convertedTo: 'converti en',
      grandTotal: 'Total général',
      
      // Unit Types & Measurements
      unitType: 'Type d\'unité',
      unitTypeHint: 'Sélectionnez comment cet article est mesuré/vendu',
      unitTypeQuantity: 'Quantité (pièces)',
      unitTypeWeight: 'Poids (kg)',
      unitTypeLength: 'Longueur (m)',
      unitTypeArea: 'Surface (m²)',
      unitTypeVolume: 'Volume (L)',
      allowFractional: 'Autoriser les quantités décimales',
      allowFractionalHint: 'Autoriser des valeurs fractionnaires comme 0,5, 1,25, 2,75',
      weightKg: 'Poids (kg)',
      lengthM: 'Longueur (m)',
      areaM2: 'Surface (m²)',
      volumeL: 'Volume (L)',
      kg: 'kg',
      meter: 'm',
      squareMeter: 'm²',
      liter: 'L',
      pieces: 'pièces',
      enterWeight: 'Entrer le poids',
      enterLength: 'Entrer la longueur',
      enterArea: 'Entrer la surface',
      enterVolume: 'Entrer le volume',
      enterValidMeasurement: 'Veuillez entrer une mesure valide',
      availableQuantity: 'Disponible',
      confirm: 'Confirmer',
      
      // Reports
      reports: 'Rapports',
      profitsAndReports: 'Profits & Rapports',
      profitByItem: 'Profit par article',
      totalProfitUSD: 'Profit total (USD)',
      totalProfitLBP: 'Profit total (LBP)',
      totalItemsSold: 'Total articles vendus',
      totalSold: 'Total vendu',
      profitUSD: 'Profit (USD)',
      profitLBP: 'Profit (LBP)',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      applyFilter: 'Appliquer le filtre',
      salesTypeFilter: 'Type de ventes',
      allSalesTypes: 'Toutes les ventes',
      exportCSV: 'Exporter CSV',
      exportSuccess: 'Fichier exporté avec succès',
      salesChart: 'Graphique des ventes',
      salesCount: 'Nombre de ventes',
      loading: 'Chargement',
      noDataForPeriod: 'Aucune donnée disponible pour cette période',
      invalidDateRange: 'Plage de dates invalide',
      profitByCategory: 'Profit par catégorie',
      salesByCategory: 'Ventes par catégorie',
      profitByCurrency: 'Profit par devise',
      salesByCurrency: 'Ventes par devise',
      salesPercentageByItem: 'Distribution des ventes par article',
      dailySalesChart: 'Ventes quotidiennes',
      dailyRevenue: 'Revenu quotidien',
      dailySalesCount: 'Nombre de ventes quotidiennes',
      profit: 'Profit',
      errorFetchingReports: 'Erreur lors de la récupération des rapports',
      errorFetchingItems: 'Erreur lors de la récupération des articles',
      
      // Offline
      offlineWarning: 'Vous êtes hors ligne - les modifications seront synchronisées en ligne',
      connectionRestored: 'Connexion restaurée - synchronisation en cours',
      pendingChanges: 'Modifications en attente',
      syncingChanges: 'Synchronisation en cours...',
      
      // Page du marché public
      marketNotFound: 'Marché introuvable',
      inStock: 'En stock',
      outOfStock: 'Rupture de stock',
      addToCart: 'Ajouter au panier',
      addedToCart: 'Ajouté au panier',
      invalidQuantity: 'Quantité invalide',
      continueShopping: 'Continuer les achats',
      newOrder: 'Nouvelle commande',
      visitStore: 'Visitez le magasin',
      subtotal: 'Sous-total',
      orderViaWhatsApp: 'Commander via WhatsApp',
      remainingStock: 'Stock restant',
      whatsAppOpenedSuccess: 'WhatsApp s\'ouvrira maintenant',
      phoneNumberNotAvailable: 'Numéro de téléphone non disponible',
      invalidPhoneNumber: 'Numéro de téléphone invalide',
      
      // Receipts
      receipts: 'Reçus',
      searchReceipt: 'Rechercher un reçu',
      receiptNumber: 'Numéro du reçu',
      enterReceiptNumber: 'Entrez le numéro du reçu',
      recentReceipts: 'Reçus récents',
      allReceipts: 'Tous les reçus',
      debtReceipts: 'Reçus de crédit',
      wholesaleReceipts: 'Reçus de gros',
      retailReceipts: 'Reçus de détail',
      receiptNotFound: 'Reçu non trouvé',
      receiptUpdated: 'Reçu mis à jour',
      receiptDeleted: 'Reçu supprimé',
      errorUpdatingReceipt: 'Erreur lors de la mise à jour du reçu',
      errorDeletingReceipt: 'Erreur lors de la suppression du reçu',
      confirmDeleteReceipt: 'Êtes-vous sûr de vouloir supprimer ce reçu?',
      date: 'Date',
      seller: 'Vendeur',
      notes: 'Notes',
      enterNotes: 'Entrez les notes...',
      backToSearch: 'Retour à la recherche',
      saving: 'Enregistrement',
      pleaseEnterReceiptNumber: 'Veuillez entrer un numéro de reçu',
      searchByCustomer: 'Rechercher par nom du client',
      searchByItem: 'Rechercher par article',
      fromDate: 'Date de début',
      toDate: 'Date de fin',
      clearFilters: 'Effacer les filtres',
      allPayments: 'Tous les paiements',
      allInvoices: 'Toutes les factures',
      editItems: 'Modifier les articles',
      qty: 'Quantité',
      price: 'Prix',
      total: 'Total',
      
      // Categories & Brands
      categoriesAndBrands: 'Catégories et marques',
      categories: 'Catégories',
      brands: 'Marques',
      addCategory: 'Ajouter une catégorie',
      editCategory: 'Éditer la catégorie',
      addBrand: 'Ajouter une marque',
      editBrand: 'Éditer la marque',
      selectCategory: 'Sélectionner une catégorie',
      selectBrand: 'Sélectionner une marque',
      manageCategoriesAndBrands: 'Gérer les catégories et les marques',
      brand: 'Marque',
      english: 'English',
      deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cet élément?',
      created: 'Créé avec succès',
      updated: 'Mis à jour avec succès',
      deleted: 'Supprimé avec succès',
      noData: 'Aucune donnée disponible',
      
      // Panneau d'administration
      admin: 'Administration',
      adminPanel: 'Panneau d\'administration',
      manageMarkets: 'Gérez tous les magasins et consultez les statistiques',
      markets: 'Magasins',
      fees: 'Frais',
      market: 'Magasin',
      addMarket: 'Ajouter un nouveau magasin',
      createNewMarket: 'Créer un nouveau magasin',
      marketInfo: 'Informations du magasin',
      marketName: 'Nom du magasin',
      enterMarketName: 'Entrez le nom du magasin',
      phone: 'Téléphone',
      enterPhone: 'Entrez le numéro de téléphone',
      email: 'Email',
      enterEmail: 'Entrez l\'adresse e-mail',
      ownerAccount: 'Compte propriétaire',
      username: 'Nom d\'utilisateur',
      enterUsername: 'Entrez le nom d\'utilisateur',
      password: 'Mot de passe',
      enterPassword: 'Entrez le mot de passe',
      language: 'Langue',
      createMarket: 'Créer le magasin',
      creating: 'Création en cours...',
      
      // Gestion des utilisateurs
      manageUsers: 'Gérer les utilisateurs',
      createNewUser: 'Créer un nouvel utilisateur',
      allMarkets: 'Tous les magasins',
      allRoles: 'Tous les rôles',
      filterByMarket: 'Filtrer par magasin',
      filterByRole: 'Filtrer par rôle',
      role: 'Rôle',
      superadmin: 'Super Admin',
      owner: 'Propriétaire',
      systemWide: 'Système complet',
      noUsersFound: 'Aucun utilisateur trouvé',
      fillAllRequiredFields: 'Veuillez remplir tous les champs requis',
      passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
      userCreatedSuccessfully: 'Utilisateur créé avec succès',
      errorCreatingUser: 'Erreur lors de la création de l\'utilisateur',
      userStatusUpdated: 'Statut de l\'utilisateur mis à jour',
      confirmDeleteUser: 'Êtes-vous sûr de vouloir supprimer cet utilisateur?',
      userDeletedSuccessfully: 'Utilisateur supprimé avec succès',
      errorDeletingUser: 'Erreur lors de la suppression de l\'utilisateur',
      selectMarket: 'Sélectionner un magasin',
      minPasswordLength: 'Minimum 6 caractères',
      deactivate: 'Désactiver',
      activate: 'Activer',
      create: 'Créer',
      dateJoined: 'Date d\'inscription',
      
      marketCreatedSuccessfully: 'Magasin créé avec succès',
      errorCreatingMarket: 'Erreur lors de la création du magasin',
      items: 'Articles',
      totalSalesUSD: 'Ventes totales (USD)',
      totalSalesLBP: 'Ventes totales (LBP)',
      totalProfitUSD: 'Profit total (USD)',
      totalProfitLBP: 'Profit total (LBP)',
      fesDue: 'Frais dus',
      users: 'Utilisateurs',
      established: 'Établi',
      status: 'Statut',
      amount: 'Montant',
      reason: 'Raison',
      dateCreated: 'Date de création',
      paid: 'Payé',
      pending: 'En attente',
      action: 'Action',
      storeLink: 'Lien du magasin',
      openStore: 'Ouvrir le magasin',
      copyLink: 'Copier le lien',
      linkCopied: 'Lien copié',
      noOwner: 'Pas de propriétaire',
      
      // Images
      addImages: 'Ajouter des images',
      uploadImages: 'Télécharger les images',
      selectImages: 'Sélectionner les images',
      imagesUploaded: 'Images téléchargées avec succès',
      errorUploadingImages: 'Erreur lors du téléchargement des images',
      notAnImage: "n'est pas une image",
      fileTooLarge: 'fichier trop volumineux (max 5MB)',
      dragAndDrop: 'ou glissez-déposez les images ici',
      imageLimits: 'Max 5MB par image, PNG/JPG',
      uploading: 'Téléchargement en cours...',
      primary: 'Primaire',
      noImages: 'Pas d\'images',
      
      noFeesFound: 'Aucun frais trouvé',
      feePaidSuccessfully: 'Frais marqués comme payés avec succès',
      errorMarkingFeePaid: 'Erreur lors du marquage des frais comme payés',
      fillAllFields: 'Veuillez remplir tous les champs requis',
      errorFetchingData: 'Erreur lors de la récupération des données',
      accessDenied: 'Accès refusé',
      editMarket: 'Modifier le marché',
      marketUpdatedSuccess: 'Le marché a été mis à jour avec succès',
      errorUpdatingMarket: 'Erreur lors de la mise à jour du marché',

      
      // Débiteurs (Gestion des dettes)
      debtors: 'Débiteurs',
      debtorsManagement: 'Gestion des dettes',
      title: 'Gestion des dettes',
      addDebtor: 'Ajouter un débiteur',
      editDebtor: 'Modifier le débiteur',
      deleteDebtor: 'Supprimer le débiteur',
      debtorName: 'Nom du débiteur',
      debtorPhone: 'Téléphone du débiteur',
      debtorDetails: 'Détails du débiteur',
      totalDebtors: 'Total des débiteurs',
      totalDebt: 'Total des dettes',
      totalPaid: 'Total payé',
      remaining: 'Restant',
      remainingDebt: 'Dette restante',
      statusPending: 'En attente',
      statusPartial: 'Partiel',
      statusPaid: 'Payé',
      allStatus: 'Tous les statuts',
      overdue: 'En retard',
      overdueCount: 'Nombre de retards',
      payment: 'Paiement',
      paymentAmount: 'Montant du paiement',
      recordPayment: 'Enregistrer le paiement',
      markPaid: 'Marquer comme payé',
      paymentRecorded: 'Paiement enregistré avec succès',
      failedToRecordPayment: 'Échec de l\'enregistrement du paiement',
      sendWhatsApp: 'Envoyer WhatsApp',
      whatsappMessage: 'Message WhatsApp',
      whatsappMessagePrepared: 'Message WhatsApp préparé - ouverture de l\'application',
      failedToSendWhatsApp: 'Échec de l\'envoi du message WhatsApp',
      debtAdded: 'Débiteur ajouté avec succès',
      debtUpdated: 'Débiteur mis à jour avec succès',
      debtDeleted: 'Débiteur supprimé avec succès',
      failedToSaveDebtor: 'Échec de la sauvegarde du débiteur',
      failedToDeleteDebtor: 'Échec de la suppression du débiteur',
      failedToFetchDebtors: 'Échec de la récupération des débiteurs',
      namePhoneRequired: 'Le nom et le téléphone sont requis',
      invalidAmount: 'Veuillez entrer un montant valide',
      searchByNameOrPhone: 'Rechercher par nom ou téléphone...',
      callDebtor: 'Appeler le débiteur',
      debt: 'Dette',
      selectDebtor: 'Sélectionner un débiteur',
      addNewDebtor: 'Ajouter un nouveau débiteur',
    },
    debtors: {
      debtorsManagement: 'Gestion des dettes',
      addDebtor: 'Ajouter un débiteur',
      editDebtor: 'Modifier le débiteur',
      deleteDebtor: 'Supprimer le débiteur',
      name: 'Nom du débiteur',
      phone: 'Téléphone du débiteur',
      details: 'Détails du débiteur',
      totalDebtors: 'Total des débiteurs',
      totalDebt: 'Total des dettes',
      totalPaid: 'Total payé',
      remaining: 'Restant',
      remainingDebt: 'Dette restante',
      status: 'Statut',
      statusPending: 'En attente',
      statusPartial: 'Partiel',
      statusPaid: 'Payé',
      allStatus: 'Tous les statuts',
      overdue: 'En retard',
      overdueCount: 'Nombre en retard',
      payment: 'Paiement',
      paymentAmount: 'Montant du paiement',
      recordPayment: 'Enregistrer le paiement',
      markPaid: 'Marquer comme payé',
      paymentRecorded: 'Paiement enregistré avec succès',
      failedToRecordPayment: 'Échec de l\'enregistrement du paiement',
      sendWhatsApp: 'Envoyer WhatsApp',
      whatsappMessage: 'Message WhatsApp',
      whatsappMessagePrepared: 'Message WhatsApp préparé - ouverture de l\'application',
      failedToSendWhatsApp: 'Échec de l\'envoi du message WhatsApp',
      debtAdded: 'Débiteur ajouté avec succès',
      debtUpdated: 'Débiteur mis à jour avec succès',
      debtDeleted: 'Débiteur supprimé avec succès',
      failedToSaveDebtor: 'Échec de la sauvegarde du débiteur',
      failedToDeleteDebtor: 'Échec de la suppression du débiteur',
      cannotDeleteCustomerWithInvoices: 'Impossible de supprimer un client avec des factures',
      failedToFetchDebtors: 'Échec de la récupération des débiteurs',
      namePhoneRequired: 'Le nom et le téléphone sont requis',
      invalidAmount: 'Veuillez entrer un montant valide',
      searchByNameOrPhone: 'Rechercher par nom ou téléphone...',
      callDebtor: 'Appeler le débiteur',
      debtorName: 'Nom du débiteur',
      debtorPhone: 'Téléphone du débiteur',
      debtorDetails: 'Détails du débiteur',
      viewDetails: 'Voir les détails',
      customerStatistics: 'Statistiques du client',
      accountStatement: 'Releve de compte',
      paymentHistory: 'Historique des paiements',
      statementGeneratedAt: 'Genere le',
      failedToLoadStatement: 'Echec du chargement du releve',
      noDataAvailable: 'Aucune donnee disponible',
      receiptNumber: 'Numero du recu',
      totalInvoices: 'Total des factures',
      debtInvoices: 'Factures de dettes',
      totalSalesUSD: 'Total des ventes (USD)',
      totalSalesLBP: 'Total des ventes (LBP)',
      debtUSD: 'Dette (USD)',
      debtLBP: 'Dette (LBP)',
      salesInfo: 'Informations sur les ventes',
      debtInfo: 'Informations sur les dettes',
      
      // Wholesale/Box Selling
      wholesale: 'Vente en gros',
      retail: 'Détail',
      wholesaleSales: 'Ventes en gros',
      retailSales: 'Ventes au détail',
      wholesaleInvoice: 'Facture de gros',
      sellWholeBox: 'Vendre carton entier',
      sellwollbox: 'Vendre carton entier',
      sellwellbox: 'Vendre carton entier',
      wholeBoxAdded: 'Carton ajoute: {{item}}',
      batchNotFull: 'Impossible de vendre le carton entier - carton incomplet',
      batchnotfull: 'Impossible de vendre le carton entier - carton incomplet',
      noBatchAvailable: 'Aucun lot disponible pour cet article',
      insufficientStockForBox: 'Stock insuffisant pour un carton entier',
      noBoxPriceSet: 'Prix du carton non défini pour ce lot',
      errorAddingBox: 'Erreur lors de l\'ajout du carton entier',
      cannotEditBatchCode: 'Le code du lot ne peut pas être modifié après création',
    }
  }
};

const getInitialLanguage = () => {
  try {
    return localStorage.getItem('language') || 'en';
  } catch (error) {
    return 'en';
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
